module.exports = __webpack_public_path__ + "static/img/1666.7916473.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s32/pop/1666.png
// module id = UL98
// module chunks = 2